import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'zano'),
  es: flattenMessages(es, 'zano'),
  ru: flattenMessages(ru, 'zano'),
  zh: flattenMessages(zh, 'zano'),
};
